export function homeForRole(role) {
  if (role === "waiter") return "/waiter";
  if (role === "kitchen") return "/kitchen";
  return "/";
}

const ENTERPRISE_PATHS = [
  "/chain", "/accounting", "/printers", "/whatsapp", "/brands", "/aggregator", "/mess",
  "/transfers", "/purchase-invoices", "/floor-setup", "/permissions", "/subscription",
];

export function canAccess(role, path) {
  if (role === "admin" || role === "manager") return true;
  if (role === "waiter") return path.startsWith("/waiter") || path.startsWith("/calls");
  if (role === "kitchen") return path.startsWith("/kitchen") || path.startsWith("/kds");
  if (role === "staff") {
    if (ENTERPRISE_PATHS.some((p) => path === p || path.startsWith(`${p}/`))) return false;
    return !["/waiter", "/kitchen", "/approvals", "/staff"].some((p) => path === p || path.startsWith(`${p}/`));
  }
  return true;
}
